import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import BarGraph from "@components/graphStatistics/Bar/Graphs";

export default function AntiquityGraph({ _lists, average, details }) {
  /** */
  const { t: statTranslator } = useTranslation("pages.employés.statistics");
  const [graphData, setGraphData] = useState({});

  const maxAges = Math.max(..._lists.map(emp => emp.difference / 12));

  const graphOptions = useMemo(() => {
    return {
      //Customize chart options
      tooltips: {
        bodyFontSize: 15,
        caretSize: 8,
        titleFontSize: 13,
        callbacks: {
          title: (item) => {
            return item[0].datasetIndex
              ? statTranslator("Moyenne")
              : item[0].label;
          },
          label: (item) => {
            const value = +item.value;
            return (
              (parseInt(value)
                ? parseInt(value) + ` ${statTranslator("an(s)")}`
                : "") +
              ((value * 12) % 12)?.toFixed(0) +
              ` ${statTranslator("mois")}`
            );
          }
        }
      },
      legend: {
        display: false
      },
      scales: {
        yAxes: [
          {
            ticks: {
              //max: 20,
              min: 0,
              stepSize: Math.ceil(maxAges / 7),
              callback: function (value, index, values) {
                return value;
              }
            }
          }
        ],
        xAxes: [
          {
            maxBarThickness: 50
          }
        ]
      }
    };
  }, [maxAges]);

  useEffect(() => {
    const dataAnciennete = {
      labels: _lists?.map((x) => x.fullname) || [],
      datasets: [
        {
          label: "test",
          backgroundColor: "#9AD0F6",
          borderColor: "#8CADC5",
          borderWidth: 0.5,
          data: _lists?.map((x) => x.difference / 12) || []
        },
        // {
        //   label: statTranslator("Moyenne"),
        //   backgroundColor: "transparent",
        //   pointBackgroundColor: "#9AD0F6",
        //   pointBorderWidth: 2,
        //   borderColor: "#8CADC5",
        //   data: _lists?.length
        //     ? new Array(_lists.length).fill(average / 12)
        //     : [],
        //   // stack: 1,
        //   //type: "line"
        // }
      ]
    };
    setGraphData(dataAnciennete);
  }, [_lists, average]);

  return (

    <BarGraph
      legends={
        <div className="arh-flex arh-space-x-3 arh-items-center">
          <span className="arh-w-3 arh-h-3 arh-bg-[#9ad0f6]"></span>
          <span className="arh-font-poppins arh-text-xs arh-text-darkColor arh-font-medium">
            {statTranslator("Nombre d’années")}
          </span>
        </div>
      }
      graphData={graphData}
      title={statTranslator("Ancienneté")}
      graphOptions={graphOptions}
      target="antiquity"
      description={
        <>
          <div className="arh-text-base arh-font-medium">{statTranslator("Chiffres en détail")}</div>
          <div className="arh-flex arh-flex-col arh-space-y-2 ">
            <div className="arh-text-xs"><span className="arh-mr-2">{statTranslator("La plus récente")}:</span> <span className="arh-text-[#859298] "> {statTranslator("année", { count: details?.minAgeExp })}</span></div>
            <div className="arh-text-xs"><span className="arh-mr-2">{statTranslator("Moyenne")}:</span> <span className="arh-text-[#859298] ">{statTranslator("année", { count: details?.avgAgeExp })} </span></div>
            <div className="arh-text-xs"><span className="arh-mr-2">{statTranslator("La plus ancienne")}:</span> <span className="arh-text-[#859298] ">{statTranslator("année", { count: details?.maxAgeExp })}</span></div>
          </div>
        </>
      }
    />
  );
}
